export default function($) {
  var speed = 150; // ms

  $('.js-nav-mobile-button').click(function () {
    if($('.js-nav-items').hasClass('nav-items-active')) {
      $('.js-nav-items').slideUp(speed);
      $('.js-nav-items .js-nav-close').remove();
      $('.js-nav-items').removeClass('nav-items-active');
      $(this).removeClass('nav-trigger-active');
    } else {
      $('.js-nav-items').slideDown(speed);
      $('.js-nav-items').prepend('<li class="js-nav-close fixed right-4 top-4 z-20 w-8 h-8"><svg class="cursor-pointer block w-8 h-8 fill-secondary-900" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6L19 6.4z"/></svg></li>');
      $('.js-nav-items').addClass('nav-items-active');
      $(this).addClass('nav-trigger-active');
    }
  });

  $('.js-nav-items').on('click', '.js-nav-close svg', function() {
    $('.js-nav-items').slideUp(speed);
    $('.js-nav-items .js-nav-close').remove();
    $('.js-nav-items').removeClass('nav-items-active');
    $('.js-nav-mobile-button').removeClass('nav-trigger-active');
  })

  $('.menu-item-has-children').click(function () {
    $(this).siblings('.menu-item-has-children--active').each(function(i, sibling) {
      $(sibling).removeClass('menu-item-has-children--active').children('.sub-menu').slideUp(speed);
    });
    $(this).children('.sub-menu').slideToggle(speed);
    $(this).toggleClass('menu-item-has-children--active');
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.js-nav').length) {
      if ($('.sub-menu').is(":visible")) {
        $('.sub-menu').slideUp(speed);
        $('.menu-item-has-children--active').removeClass('menu-item-has-children--active');
      }
      if($('.js-nav-items').hasClass('nav-items-active')) {
        $('.js-nav-items').slideUp(speed);
        $('.js-nav-items').removeClass('nav-items-active');
        $('.js-nav-mobile-button').removeClass('nav-trigger-active');
      }
    }
  });

  $(window).resize(function() {
    if( $(window).outerWidth() >= 1280) {
      $('.js-nav-items').css('display', 'flex');
    } else {
      $('.js-nav-items').css('display', 'none');
      $('.js-nav-items').removeClass('nav-items-active');
      $('.js-nav-mobile-button').removeClass('nav-trigger-active');
      $('.js-nav-items .js-nav-close').remove();
    }
  })

  $(window).scroll(function() {
    if ($(this).scrollTop() >= 100) {
      $('.js-backtotop').fadeIn();
    } else {
      $('.js-backtotop').fadeOut();
    }
  });
}
